import ErrorBoundary from '@/components/ErrorBoundary';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { withColumnsSystem } from 'lib/utils/withGridSystem';
import { renderContentComponent } from 'modules/dynamic-components';
import { Fragment, ReactNode } from 'react';
import { Columns, ColumnsProps } from './Columns';

export interface StandaloneColumnsProps extends StandaloneComponentProps {
  content?: ReactNode;
  options?: ColumnsProps;
}

export const StandaloneColumns: StandaloneComponent<StandaloneColumnsProps> = ({ content, options, ...props }) => {
  const { ...baseProps } = options ?? {};

  return (
    <ErrorBoundary>
      <Columns {...baseProps} {...props}>
        {content}
      </Columns>
    </ErrorBoundary>
  );
};

export const standalone = StandaloneColumns;

const LabradorColumns: LabradorComponent = ({ type, data, meta, descendants }) => {
  const contentIndex = meta.contentIndex;

  if (!descendants?.length) {
    return null;
  }

  const content = descendants.map((child, index) => {
    return <Fragment key={index}>{renderContentComponent(child)}</Fragment>;
  });

  return (
    <StandaloneColumns
      options={{ className: withColumnsSystem(meta.width) }}
      data-content-index={contentIndex}
      {...{ content }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorColumns;
